import React, {Fragment} from 'react';

const Dashboard = () => {
  return (
    <Fragment>Dashboard View</Fragment>
  );
};

export default Dashboard;
